import router from './index'
import store from '../store/index'
import { MessageBox, Message } from 'element-ui'
import windowConfig from '@/utils/windowConfig'
import API from '@/api'
import Vue from 'vue'

window.ossConfig = {
    ...windowConfig.commonOssConfig,
    ...windowConfig.ossConfig[process.env.NODE_ENV]
}

router.beforeEach(async (to, from, next) => {
    // 如果没修改密码，则强制跳转到修改密码

    const ifNeedChangePassword = localStorage.getItem('please_change_password')
    if (
        ifNeedChangePassword == 1 &&
        !['/changePassword', '/login'].includes(to.path) &&
        vm.$store.getters['common/getUser'].userType == '2'
    ) {
        Message.warning(vm.$i18n.t('PASSWORD_CHANGE_MESS'))
        next('/changePassword')
    }

    // 在itu detail页，如果页面数据未保存，路由跳转拦截
    if (from.path == '/ita' && window.__itu_answerChanged === true) {
        try {
            await MessageBox.confirm(vm.$i18n.t('ita_unsave_answer_notice'))
            window.__itu_answerChanged = false
        } catch (e) {
            console.error(e)
            return false
        }
    }

    // 从ita页面离开，要清除掉自动保存定时任务
    if (from.path == '/ita' && to.path != '/ita' && window.autoSaveIntervalInst) {
        clearInterval(window.autoSaveIntervalInst)
    }

    let href = window.location.href
    let redirectFlag = ''
    if (href.indexOf('?') !== -1 && href.split('?')[1].indexOf('=') != -1 && href.split('?')[1].split('=')[0] === 'redirectFlag') {
        redirectFlag = href.split('?')[1].split('=')[1] || ''
    }
    const isLogin = sessionStorage.getItem('JSESSIONID')
    const whiteList = [
        'login',
        'forgetPassword',
        'internError',
        '403',
        '404',
        'notSite',
        'notRole',
        'changePassword',
        'newPbcList',
        'autoFetch',
        'faq',
        'businessHome',
        'client',
        'courseContent',
        'courseList',
        'myCourse',
        'courseDetail',
        'keeList',
        'keeListNew',
        'myCourseNew',
        'courseDetailNew',
        'csConsult',
        'group',
        'admin',
        'confirmationGuide',
        'confirmation'
    ]
    if (!isLogin) {
        // confirmation 审计函证平台重定向
        if (to.name === 'confirmation') {
            if (to.query.siteClassification) {
                sessionStorage.setItem('siteClassification', to.query.siteClassification)
            }
            // if (localStorage.getItem('JSESSIONID')) {
            //     sessionStorage.setItem('JSESSIONID', localStorage.getItem('JSESSIONID'))
            //     next()
            //     return
            // }
            sessionStorage.setItem('redirectUrl', JSON.stringify({name: to.name, query: to.query}));
        }
        //获取用户Ip
        let userRegion = 'overseas'
        const res = await API.common.getUserRegion()
        if (res.code == '1' && res.data == '0') {
            userRegion = 'cn'
        }

        if (
            to.name === 'login' ||
            to.name === 'forgetPassword' ||
            to.name === 'autoFetch' ||
            to.name === 'internError' ||
            to.name === 'faq' ||
            to.name === 'confirmationGuide'
        ) {
            next()
        } else if (to.name == 'login' || redirectFlag === '1') {
            next({ name: 'login' })
        } else {
            if (to.name == 'pbc' && to.query.siteId && to.query.siteId.length > 0) sessionStorage.setItem('redirectUrl', JSON.stringify(to))

            const engagementCode = to.query.engagementCode

            let result
            if (process.env.NODE_ENV !== 'development') {
                if (['kcc.kpmg.com.cn'].includes(window.location.host)) {
                    // 客户端跳login
                    result = '/#/login'
                    next({ name: 'login' })
                } else {
                    // kp 端跳sso,区分cn和overseas
                    if (engagementCode) {
                        result = `${window.ossConfig[userRegion].authority}?response_type=id_token&client_id=${window.ossConfig[userRegion].client_id}&redirect_uri=${window.ossConfig[userRegion].redirect_uri}?engagementCode=${engagementCode}&scope=openid%20profile&state=af0ifjsldkj&response_mode=form_post&nonce=${window.location.href}`
                    } else {
                        result = `${window.ossConfig[userRegion].authority}?response_type=id_token&client_id=${window.ossConfig[userRegion].client_id}&redirect_uri=${window.ossConfig[userRegion].redirect_uri}&scope=openid%20profile&state=af0ifjsldkj&response_mode=form_post&nonce=${window.location.href}`
                    }
                    window.location.replace(result)
                }
            } else {
                result = `${window.ossConfig.authority}&once=${window.location}&engagementCode=${engagementCode}`
                window.location.replace(result)
            }
        }
    } else {
        let user = store.state.common.user,
            homeName = ''

        if (user.userType === '2') {
            homeName = 'businessHome'
        } else if (user.userType == '1' && !user.hasSiteBind && user.isSystemAdmin) {
            homeName = 'system'
        } else if (user.userType === '1' && user.isSecurityAuditor) {
            homeName = 'auditTrail'
        } else {
            homeName = 'businessHome'
        }

        let findStack = _plainTree(whiteList)

        // 如果有exchange权限，则添加ita权限
        if (findStack.includes('exchange') && !findStack.includes('ita')) {
            findStack.push('ita')
        }

        // 如果不是站点管理员，则把站点管理员的功能都排除
        if (store.state.common.siteInfo.isSiteAdmin === false) {
            ;['general', 'kpUserRole', 'kpmgTeamMember', 'clientRoles', 'clientUsers', 'groupReportingRole', 'groupReportingUser'].forEach(
                (v) => {
                    const findIndex = findStack.findIndex((vv) => vv == v)
                    if (findIndex > -1) {
                        findStack.splice(findIndex, 1)
                    }
                }
            )
        }

        // 如果是组成部分用户，则把客户主页面里除了集团审计之外的功能都排除
        if (localStorage.getItem('isComponentMember') == 'true') {
            ;['exchange', 'pbc', 'accounts', 'matterLogs', 'insights', 'confirmation'].forEach((v) => {
                const findIndex = findStack.findIndex((vv) => vv == v)
                if (findIndex > -1) {
                    findStack.splice(findIndex, 1)
                }
            })
        }

        const isAuth = _.findIndex(findStack, (v) => v === to.name) !== -1

        if (to.name === 'login' || to.name === 'home') {
            const engagementCode = to.query.engagementCode
            if (homeName === 'businessHome' && engagementCode) {
                next({
                    name: homeName,
                    query: {
                        engagementCode
                    }
                })
            } else {
                next(homeName)
            }
        } else if (!isAuth) {
            if (user.userType == '1' && homeName === 'businessHome') {
                next({ name: 'notSite' })
            } else {
                next({ name: '403' })
            }
        } else {
            next()
        }
    }
})

function _plainTree(whiteList) {
    let _data = []

    const _find = function (data) {
        for (let i = 0; data && i < data.length; i++) {
            let hasChildren = _.isArray(data[i].childMenuList)
            if (hasChildren && data[i].childMenuList.length > 0) {
                _find(data[i].childMenuList)
            }
            _data.push(data[i])
        }
    }

    _find(store.state.common.user.menuList)

    return _.concat(
        _.map(_data, (v) => v.href),
        whiteList
    )
}
